module.exports = __webpack_public_path__ + "img/img_hope03.f5f948f3.png";